var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.39,
    height: 12.39,
    viewBox: "0 0 12.39 12.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.39,
    height: 12.39
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.39,
    height: 12.39,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clear-notification-icon",
    d: "M9.508,13.25l3.516-3.516a1.044,1.044,0,0,0,0-1.547l-.773-.773a1.044,1.044,0,0,0-1.547,0L7.188,10.93,3.637,7.414a1.044,1.044,0,0,0-1.547,0l-.773.773a1.044,1.044,0,0,0,0,1.547L4.832,13.25,1.316,16.8a1.044,1.044,0,0,0,0,1.547l.773.773a1.044,1.044,0,0,0,1.547,0l3.551-3.516L10.7,19.121a1.044,1.044,0,0,0,1.547,0l.773-.773a1.044,1.044,0,0,0,0-1.547Z",
    transform: "translate(-0.974 -7.071)",
    fill: "#e8e8e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearNotificationIcon);
export default __webpack_public_path__ + "static/media/clear-notification-icon.b622e9fbcb4ee8747ff9b13831cda27a.svg";
export { ForwardRef as ReactComponent };